import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { LogoutComponent } from './pages/logout/logout.component';
import { RoutesManagerComponent } from '@un-fao/lightforms-lib/lightforms-core';
import { AuthGuard } from '@un-fao/lightforms-lib/lightforms-services';

const routes: Routes = [  
  { path: '', redirectTo: 'home/:lang', pathMatch: 'full' },
  { path: ':lang', redirectTo: 'home/:lang', pathMatch: 'full' },  
  { path: 'login/:lang', redirectTo: 'home/:lang', pathMatch: 'full' },
  { path: 'logout/:lang', component: LogoutComponent, pathMatch: 'full' }, 
  { 
    path: '**',
    canActivate: [AuthGuard],
    component: RoutesManagerComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
})
],
exports: [RouterModule]
})
export class AppRoutingModule { }

export const routedComponents = [];
